<template>
  <v-layout>
    <v-flex xs5>
      <service-as-badge :service-id="serviceInfo.serviceId" class="unimInlineBlock"/>
    </v-flex>
    <v-flex xs4 align-self-center>
      <service-quantity-info
        :requested-quantity="serviceInfo.requestedQuantityAllTime"
        :requested-quantity-in-period="serviceInfo.requestedQuantity"
        :executed-quantity="serviceInfo.executedQuantityAllTime"
        :executed-quantity-in-period="serviceInfo.executedQuantity"
      />
    </v-flex>
  </v-layout>
</template>

<script>
  import ServiceAsBadge from '../Ui/mcc/ServiceAsBadge'
  import DevMode from '../Ui/DevMode'
  import CaseServiceLogEvent from '../Sales/case/CaseServiceLogEvent'
  import ServiceQuantityInfo from "./ServiceQuantityInfo";

  export default {
    name: 'service-info',
    components: {
      ServiceAsBadge,
      CaseServiceLogEvent,
      DevMode,
      ServiceQuantityInfo
    },
    props: {
      serviceInfo: {
        type: Object,
        required: true
      }
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/ServiceInfo.vue